export default __webpack_public_path__ + "static/media/explainer_bank@2x.9fad7a63.png";